import React from 'react';
import styled from 'styled-components';
import { select } from '@panel/commons/core/themev2';
import CloseBtn from '@panel/commons/assets/icons/close.svg';

const Step = ({
  title,
  bodyText,
  onClose,
  children,
  withClose,
  positionClose,
  colorText,
  fontSizeTitle,
  fontWeightTitle
}) => {
  return (
    <StepContainer>
      <UpperArea>
        <Title data-panel='panel-tour-title' fontSize={fontSizeTitle} fontWeight={fontWeightTitle}>
          {title}
        </Title>
        <Close data-panel='panel-tour-close' onClick={onClose} withClose={withClose} positionClose={positionClose} />
      </UpperArea>
      {children}
      <BodyText data-panel='panel-tour-text' colorText={colorText}>
        {bodyText}
      </BodyText>
    </StepContainer>
  );
};

const StepContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
  white-space: normal;
`;

const UpperArea = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: relative;
`;

const Title = styled.h1`
  font-family: Hind;
  font-size: ${({ fontSize }) => fontSize || '16px'};
  font-style: normal;
  font-weight: ${({ fontWeight }) => fontWeight || '400'};
  line-height: 130%;
  white-space: normal;
`;

const Close = styled.div`
  background-image: ${`url(${CloseBtn})`};
  width: ${({ withClose }) => withClose || '18px'};
  height: 26px;
  background-size: contain;
  background-repeat: no-repeat;
  cursor: pointer;
  position: ${({ positionClose }) => positionClose || 'unset'};
  right: -12px;
  top: -12px;
`;

const BodyText = styled.div`
  font-family: Hind;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  text-align: left;
  white-space: break-spaces;
  color: ${({ colorText }) => select(colorText || 'darkGray')};
  max-width: 100%;
`;

export default Step;
